import React, { cloneElement, ReactElement } from 'react';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

interface RegistrationStatusProps {
    iconSlot?: ReactElement;
    messageSlot?: ReactElement;
    helpSlot?: ReactElement;
    title?: string;
}

export const RegistrationStatus = (props: RegistrationStatusProps) => {
    const { iconSlot, messageSlot, helpSlot, title } = props;

    return (
        <>
            <Flex
                px={2}
                width="100%"
                height={{ xs: '100%', sm: 'auto' }}
                borderRadius={{ sm: 2 }}
                backgroundColor="var(--background-primary)"
            >
                <Box pt={2}>{iconSlot ? cloneElement(iconSlot) : null}</Box>
                <Box py={2}>
                    <Typography variant="title3" weight="bold">
                        {title}
                    </Typography>
                </Box>
                <Box pb={2}>{messageSlot ? cloneElement(messageSlot) : null}</Box>
            </Flex>
            {helpSlot ? cloneElement(helpSlot) : null}
        </>
    );
};
